import { ComponentProps } from 'react';
import Alert from 'antd/es/alert';
import clsx from 'clsx';

import './OpBanner.scss';

interface OpBannerProps
  extends Omit<ComponentProps<typeof Alert>, 'data-testid'> {
  testId?: string;
}

export const OpBanner = ({
  testId = 'op-banner',
  className,
  ...alertProps
}: OpBannerProps) => {
  return (
    <Alert
      {...alertProps}
      banner
      className={clsx('op-banner', className)}
      data-testid={testId}
    />
  );
};
